export default {
    intro: 'Invite your colleagues to evaluate the trends in the Trendmanager. Optionally, you can send a personal message to the participants. At the end of the evaluation, you will receive an overview of which of your participants completed the evaluation completely, incompletely, or did not participate at all.',
    participants: {

    }
}
